import React, { useEffect, useState, useRef } from 'react';
import { Button, Card } from 'react-bootstrap';
import ComponentIdentifier from '../../CommonComponent/ComponentHeader/ComponentIdentifier';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { getPrintAction, getPromisedPrintAction } from '../../../Redux/Action/MemberAction';
import { useReactToPrint } from "react-to-print";
import { Link } from "react-router-dom";
import QRCode from '../../../assets/images/qr.jpg';
import Signater from '../../../assets/images/sig.jpg';
import * as htmlToImage from 'html-to-image';
import * as converter from "number-to-words"

export const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleDateString("en-GB", {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit"
    });
};

// Helper to convert external images to Base64
const toBase64 = (url) => {
    return fetch(url)
        .then(res => res.blob())
        .then(blob => new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        }))
        .catch(() => null);
};

function HardCopyPrintComponent({ printDetails, printDataAgent }) {

    const contentRef = useRef(null);
    const reactToPrintFn = useReactToPrint({ contentRef });

    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");
    const promise_token = searchParams.get("promise_token")



    const [orgLogo, setOrgLogo] = useState(null);
    const [qrBase64, setQrBase64] = useState(null);
    const [signBase64, setSignBase64] = useState(null);



    // Convert images to base64 to avoid CORS issues
    useEffect(() => {
        async function loadImages() {
            if (printDetails?.cnfg_organization?.image) {
                setOrgLogo(await toBase64(printDetails.cnfg_organization.image));
            }
            setQrBase64(await toBase64(QRCode));
            setSignBase64(await toBase64(Signater));
        }
        loadImages();
    }, [printDetails]);

    // Download as image using html-to-image
    const downloadImage = async () => {
        const node = contentRef.current;
        if (!node) return;

        await document.fonts.ready; // wait for fonts

        // Clone the node to avoid layout issues
        const clone = node.cloneNode(true);

        // Create a temporary off-screen div
        const tempDiv = document.createElement("div");
        tempDiv.style.position = "absolute";
        tempDiv.style.top = "-9999px";
        tempDiv.style.left = "-9999px";
        tempDiv.style.width = `${node.scrollWidth}px`; // full width
        tempDiv.style.height = `${node.scrollHeight}px`; // full height
        tempDiv.style.background = "white"; // ensures white background
        tempDiv.appendChild(clone);
        document.body.appendChild(tempDiv);

        htmlToImage
            .toPng(clone, {
                width: node.scrollWidth,
                height: node.scrollHeight,
                cacheBust: true,
                useCors: true,
            })
            .then((dataUrl) => {
                const link = document.createElement("a");
                link.download = "voucher.png";
                link.href = dataUrl;
                link.click();

                // remove temporary div
                document.body.removeChild(tempDiv);
            })
            .catch((err) => {
                console.error("Error converting to PNG:", err);
                document.body.removeChild(tempDiv);
            });
    };
    console.log(printDetails)


    return (
        <>
            <Card>
                <Card.Header className="d-flex align-items-center justify-content-between">
                    <ComponentIdentifier link_name={"Herd copy"} component_name={""} />
                </Card.Header>
                <Card.Body>
                    <div
                        className="bill-container"
                        id="collection-invoice"
                        ref={contentRef}
                        style={{ background: "white", padding: "20px" }}
                    >
                        <div className="header">
                            {orgLogo && <img src={orgLogo} alt="" width="80" />}
                            <h4>{promise_token ? "PROMISED BILL" : "DONATION BILL"}</h4>
                            <h3>{printDetails?.cnfg_organization?.organization_name}</h3>
                        </div>

                        <div className="item-details">
                            <p>
                                <span><strong>Date:</strong> {formatDate(printDetails.createdAt)}</span>
                                <span><strong>Bill No:</strong> {printDetails.id}</span>
                            </p>
                            <hr />
                            <p>
                                <span><strong>Donor’s:</strong></span>
                                <span>{printDetails?.member?.member_name}</span>
                            </p>
                            <p>
                                <span><strong>Address:</strong></span>
                                <span>{`${printDetails?.member?.village ? printDetails?.member?.village : ""}${printDetails?.member?.village ? "," : ""} ${printDetails?.member?.police_station ? printDetails?.member?.police_station : ""}${printDetails?.member?.police_station ? "," : ""} ${printDetails?.member?.district ? printDetails?.member?.district : ""}${printDetails?.member?.district ? "," : ""} ${printDetails?.member?.state ? printDetails?.member?.state : ""} `}</span>

                            </p>
                            <hr />
                            <p>
                                <span>{printDetails.purpose}</span>
                                <span>₹ {printDetails.collection_amount}.00</span>

                            </p>

                            <p><span></span><span>{printDetails?.collection_amount && converter.toWords(printDetails.collection_amount).replace(/\b\w/g, (char) => char.toUpperCase())} Only</span></p>

                            {printDetails.purpose ? <><p><span>Purpose:</span><span>{printDetails.purpose}</span></p></> : ""}
                            {printDetails.paymeny_type ? <><p><span>Payment Type:</span><span>{printDetails.paymeny_type}</span></p></> : ""}

                            {printDetails.purpose === "Other" && (
                                <>
                                    <p><span>Goods</span> <span>{printDetails.goods}</span></p>
                                    <p><span>Quantity</span> <span>{printDetails.quantity}</span></p>
                                </>
                            )}
                        </div>
                        <hr />
                        <p>
                            {qrBase64 && <img src={qrBase64} alt="" width="100px" />}
                            <span style={{ float: "right" }}>{signBase64 && <img src={signBase64} alt="" width="80px" />}</span>
                        </p>
                        <div className="footer">
                            <h5><strong>Collector :</strong> {printDataAgent.full_name}</h5>
                            <h5>{printDataAgent.mobile}</h5>
                            <hr />
                            <h5>
                                <strong>Address:</strong> Banganur Bhavan, Kaukepara,
                                Deganga, North 24 Parganas, W.B. 743424, Contact: 9734025990
                            </h5>
                            <h5>Thank You! Please Donate Again</h5>
                        </div>
                    </div>

                    <div className="text-center mt-3">
                        <Button onClick={reactToPrintFn}>Print Now</Button> <Button as={Link} to="/all-donor" variant="dark">
                            Back
                        </Button>
                    </div>

                    {/* <div className="text-center mt-3">
                        <Button disabled onClick={downloadImage}>Download as Image</Button>
                    </div> */}
                </Card.Body>
            </Card>
        </>
    );
}

export default HardCopyPrintComponent;
